<template>
  <v-app>
    <enduser-menu />

    <common-view />

    <common-footer />

    <kdw-Cookiebar-card
      v-model="cookieUpdate"
    />
  </v-app>
</template>

<script>
  export default {
    name: 'EnduserLayout',

    data: () => {
      return { cookieUpdate: false }
    },

    components: {
      EnduserMenu: () => import('@/layouts/enduser/Menu'),
      CommonFooter: () => import('@/layouts/Footer'),
      CommonView: () => import('@/layouts/View'),
    },
  }
</script>
